import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const routes = [
  {
    path: '/landing/index',
    component: () => import('./view/landing/index.vue'),
  },
  // {
  //   path: '/home',
  //   component: () => import('./view/maththink.vue'),
  // },
];

const router = new Router({
  // mode: 'history',
  routes,
});

export default router;



// WEBPACK FOOTER //
// ./src/pages/landing-page/router.js